<div class="container-fluid my-4 px-3">
    <div class="row justify-content-between header-row">
        <mat-card-title class="font-weight-bold col-auto">
            <h1>Welcome to the Safely Admin Portal</h1>
        </mat-card-title>
    </div>

    <div class="row stat-row my-5 me-4">
        @for (stat of [ activeProperties, totalProperties, totalGuests, upcomingReservations, totalReservations, claimsInProgress ]; track stat.label) {
            <div class="col-12 col-md-4 mb-3">
                <mat-card class="stat-card" [routerLink]="stat.routerLink">
                    <mat-card-content>
                        <div class="stat-label">{{ stat.label }}</div>
                        @if (stat.loading) {
                            <div class="spinner-container stat-spinner">
                                <mat-spinner [diameter]="24"></mat-spinner>
                            </div>
                        } @else {
                            <div class="stat-value">{{ stat.value !== null ? (stat.value | number) : '—' }}</div>
                        }
                    </mat-card-content>
                </mat-card>
            </div>
        }
    </div>
</div>
